import { useAccountDeletion } from '../hooks/useAccountDeletion.js';

export function DesktopAccountDeletion() {
  const deletion = useAccountDeletion();

  return (
    <>
      <section className="desktop-account-danger-card" aria-label="계정 관리">
        <div><h3>사이트 계정 삭제</h3><p>갤로그·게임 프로필·유니온 연결을 포함한 사이트 계정을 삭제합니다. 이 작업은 되돌릴 수 없습니다.</p></div>
        <button type="button" onClick={deletion.openDialog}>계정 삭제</button>
      </section>

      {deletion.open ? (
        <div className="desktop-account-delete-overlay" role="presentation" onMouseDown={(event) => { if (event.target === event.currentTarget) deletion.closeDialog(); }}>
          <section className="desktop-account-delete-dialog" role="dialog" aria-modal="true" aria-labelledby="desktop-delete-title">
            <p className="section-eyebrow">DANGER ZONE</p>
            <h2 id="desktop-delete-title">계정을 완전히 삭제하시겠습니까?</h2>
            <p>삭제 후 로그인할 수 없으며 현재 계정에 연결된 데이터도 함께 제거됩니다. 확인을 위해 아래에 <strong>계정 삭제</strong>를 입력해주세요.</p>
            <form onSubmit={deletion.submit}>
              <label><span>삭제 확인 문구</span><input type="text" value={deletion.confirmationText} onChange={(event) => deletion.setConfirmationText(event.target.value)} placeholder="계정 삭제" autoComplete="off" autoFocus disabled={deletion.submitting} /></label>
              <label className="desktop-account-delete-check"><input type="checkbox" checked={deletion.acknowledged} onChange={(event) => deletion.setAcknowledged(event.target.checked)} disabled={deletion.submitting} /><span>계정 삭제는 되돌릴 수 없음을 확인했습니다.</span></label>
              {deletion.notice.message ? <p className={`desktop-account-delete-notice ${deletion.notice.type}`} role="status">{deletion.notice.message}</p> : null}
              <div className="desktop-account-delete-actions"><button type="button" onClick={deletion.closeDialog} disabled={deletion.submitting}>취소</button><button type="submit" className="danger" disabled={!deletion.canDelete || deletion.submitting}>{deletion.submitting ? '삭제 중…' : '계정 영구 삭제'}</button></div>
            </form>
          </section>
        </div>
      ) : null}
    </>
  );
}
